import { createAsyncThunk } from '@reduxjs/toolkit';

// Types pour les données
export interface RevenueDataItem {
  name: string;
  revenue: number;
  expenses: number;
  profit: number;
}

// Données statiques pré-définies pour chaque période
const STATIC_DATA = {
  all: [
    { name: 'Jan', revenue: 4500, expenses: 2800, profit: 1700 },
    { name: 'Feb', revenue: 5200, expenses: 3100, profit: 2100 },
    { name: 'Mar', revenue: 4800, expenses: 2900, profit: 1900 },
    { name: 'Apr', revenue: 6000, expenses: 3500, profit: 2500 },
    { name: 'May', revenue: 5800, expenses: 3300, profit: 2500 },
    { name: 'Jun', revenue: 6300, expenses: 3700, profit: 2600 },
    { name: 'Jul', revenue: 7100, expenses: 4200, profit: 2900 },
    { name: 'Aug', revenue: 7500, expenses: 4400, profit: 3100 },
    { name: 'Sep', revenue: 6800, expenses: 4000, profit: 2800 },
    { name: 'Oct', revenue: 5900, expenses: 3500, profit: 2400 },
    { name: 'Nov', revenue: 5400, expenses: 3200, profit: 2200 },
    { name: 'Dec', revenue: 6200, expenses: 3600, profit: 2600 }
  ],
  month: [
    { name: 'Sem 1', revenue: 1800, expenses: 1100, profit: 700 },
    { name: 'Sem 2', revenue: 2100, expenses: 1300, profit: 800 },
    { name: 'Sem 3', revenue: 1900, expenses: 1200, profit: 700 },
    { name: 'Sem 4', revenue: 2300, expenses: 1400, profit: 900 }
  ],
  halfyear: [
    { name: 'Jan', revenue: 4500, expenses: 2800, profit: 1700 },
    { name: 'Feb', revenue: 5200, expenses: 3100, profit: 2100 },
    { name: 'Mar', revenue: 4800, expenses: 2900, profit: 1900 },
    { name: 'Apr', revenue: 6000, expenses: 3500, profit: 2500 },
    { name: 'May', revenue: 5800, expenses: 3300, profit: 2500 },
    { name: 'Jun', revenue: 6300, expenses: 3700, profit: 2600 }
  ],
  year: [
    { name: 'Jan', revenue: 4500, expenses: 2800, profit: 1700 },
    { name: 'Feb', revenue: 5200, expenses: 3100, profit: 2100 },
    { name: 'Mar', revenue: 4800, expenses: 2900, profit: 1900 },
    { name: 'Apr', revenue: 6000, expenses: 3500, profit: 2500 },
    { name: 'May', revenue: 5800, expenses: 3300, profit: 2500 },
    { name: 'Jun', revenue: 6300, expenses: 3700, profit: 2600 },
    { name: 'Jul', revenue: 7100, expenses: 4200, profit: 2900 },
    { name: 'Aug', revenue: 7500, expenses: 4400, profit: 3100 },
    { name: 'Sep', revenue: 6800, expenses: 4000, profit: 2800 },
    { name: 'Oct', revenue: 5900, expenses: 3500, profit: 2400 },
    { name: 'Nov', revenue: 5400, expenses: 3200, profit: 2200 },
    { name: 'Dec', revenue: 6200, expenses: 3600, profit: 2600 }
  ]
};

// Thunk pour récupérer les données de revenue
export const getRevenueChartsData = createAsyncThunk(
  'dashboardEcommerce/getRevenueChartsData',
  async (period: string) => {
    // Simuler un délai réseau (optionnel)
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Retourner les données statiques correspondant à la période
    switch(period) {
      case 'month':
        return STATIC_DATA.month;
      case 'halfyear':
        return STATIC_DATA.halfyear;
      case 'year':
        return STATIC_DATA.year;
      case 'all':
      default:
        return STATIC_DATA.all;
    }
  }
);